// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//

export enum DependencyIdType {
  none = 0,
  stage = 1,
  task = 2
}

// Struct to store dependency data from portal-api
export interface DependencyDTO {
  itemId: number;                     // id of the item
  dependencyIds: Array<number>;   // ids of the tasks that this item depends on.
  itemType : DependencyIdType;      // kind of item, either stage or task.
}

// Class to handle dependency data from portal-api
export default class Dependency {
  itemId: number;
  dependencyIds: Array<number>;
  itemType : DependencyIdType;

  constructor(dto: DependencyDTO) {
    this.update(dto);
  }

  get asJson(): DependencyDTO {
    return {
      itemId: this.itemId,
      dependencyIds: this.dependencyIds,
      itemType: this.itemType
    };
  }

  update(newData: Partial<DependencyDTO>): DependencyDTO {
    const updatedData = { ...this.asJson, ...newData };

    Object.assign(this, updatedData);

    return this.asJson;
  }
}